var render, staticRenderFns
import script from "./revenuesCountItens.vue?vue&type=script&lang=js&"
export * from "./revenuesCountItens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5eae00",
  null
  
)

export default component.exports